import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

console.log('--- SPA DEBUG START ---');
console.log('Vite Base Path (from config):', "/sakuran-en_LP/");
console.log('Current URL:', window.location.href);
console.log('document.getElementById("root"):', document.getElementById('root'));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
